<template>
  <div class="badge-block">
    <div
      class="badge-block_bg"></div>
    <default-box
      class="badge-block__content"
      :class="block_classes">
        <slot></slot>
    </default-box>
  </div>
</template>

<script>
import DefaultBox from "./DefaultBox";
export default {
  name: "BadgeBlock",
  components: {DefaultBox},
  props: {
    small_badge: {
      type: Boolean,
      default: false
    },
    no_padding: {
      type: Boolean,
      default: false
    },
    bg_none: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    block_classes() {
      return {
        no_padding: this.no_padding,
        bg_none: this.bg_none,
      }
    }
  }
}
</script>
